import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';

// configure the service with tokens and content type ids
// SET YOU OWN CONFIG here
const CONFIG = {
  space: 'tke7151dd5lx',
  accessToken: '964b608a40e5db2666e3619572db5900bc7be255d5776c8f0ec1e7c32dfdd934',
  
  contentTypeIds: {
    item: 'portfolioItem',
    about: 'about'
  }
}


@Injectable()
export class ContentfulService {
  private cdaClient = createClient({
    space: CONFIG.space,
    accessToken: CONFIG.accessToken
  });

  public items: Entry<any>[] = [];
  public about : Entry<any>[] = [];
   
  constructor() { }

  getItems(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.item,
      order: "-fields.period"
    }, query))
    .then(res => res.items);
  };

  getAbout(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.about
    }, query))
    .then(res => res.items);
  };
}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/contentful.service.ts